<template>
    <div class="posts-wrapper">
        <div class="posts-wrapper-body">
            <nav class="nav-menu">
                <ul class="nav-list">
                    <li class="nav-item" @click="selectTab('All Posts')">
                        <span class="nav-text">All posts</span>
                    </li>
                    <li
                        class="nav-item"
                        v-for="tab in tabs"
                        :key="tab"
                        @click="selectTab(tab)"
                    >
                        <span class="nav-text">{{ tab }}</span>
                    </li>
                </ul>
            </nav>
            <div class="post-content">
                <template v-if="selectedTab === 'All Posts'">
                    <div class="post-content" v-if="selectedPost !== null">
                        <div class="post-content-title">{{ selectedPost.title }}</div>
                        <div v-html="selectedPost.content" class="post-content-text"></div>
                    </div>
                    <div v-else>
                        <div class="post-card" v-for="(post, index) in blogPosts" :key="index">
                            <div class="post-img">
                                <img :src="post.image" alt="blog image" />
                            </div>
                            <div class="post-body" @click="viewPost(post.slug)">
                                <div class="author-head">
                                    <div class="author-img">
                                        <img class="author-img" :src="post.avatar" alt="" />
                                    </div>
                                    <div class="author-head">
                                        <span class="head-text-title">{{ post.header }}</span>
                                    </div>
                                </div>
                                <div class="post-name">
                                    <span class="head-text"> {{ post.title }}</span>
                                    <span class="main-content" v-html="post.content"></span>
                                </div>
                            </div>
                        </div>
                        <div v-if="blogPosts.length === 0">No posts yet.</div>
                    </div>
                </template>
                <template v-else>
                    <div v-for="(post, index) in getPostsByTab(selectedTab)" :key="index">
                        <div class="post-content-title">{{ post.title }}</div>
                        <div v-html="post.content" class="post-content-text"></div>
                    </div>
                    <div v-if="getPostsByTab(selectedTab).length === 0">
                        <div class="other-tabs">
                            <span class="comming-tabs">Posts Coming Soon</span>
                            <span class="other-info"
                                >Explore other categories in this blog or check back
                                later.</span
                            >
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: 'Blog',
        data() {
            return {
                blogPosts: [],
                selectedTab: 'All Posts',
                tabs: ['Venues', 'Company updates', 'Artists'],
                selectedPost: null
            }
        },
        mounted() {
            this.fetchBlogPosts()
        },
        methods: {
            fetchBlogPosts() {
                axios
                    .get('/api/posts')
                    .then((response) => {
                        this.blogPosts = response.data.data
                    })
                    .catch((error) => {
                        console.error(error)
                    })
            },
            selectTab(tab) {
                this.selectedTab = tab
                this.selectedPost = null
            },
            viewPost(slug) {
                axios
                    .get('/api/posts/' + slug)
                    .then((response) => {
                        this.selectedPost = response.data
                    })
                    .catch((error) => {
                        console.error(error)
                    })
            },
            getPostsByTab(tab) {
                return this.blogPosts.filter((post) => post.category === tab)
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';
    ul {
        padding: 0;
        margin: 0;
    }
    .posts-wrapper {
        display: flex;
        background: rgba(22, 22, 22, 1);
        padding-left: 50px;
    }
    .posts-wrapper-body {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        flex: 1;
    }
    .nav-menu {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .nav-list {
        display: flex;
        justify-content: flex-start;
        gap: 20px;
        padding: 40px 0;
    }
    .nav-item {
        display: flex;
        align-items: center;
        white-space: nowrap;
    }
    .nav-text:hover {
        color: #cdeb09;
    }
    .nav-text {
        color: #dedede;
        font: 600 18px/120% 'Montserrat', sans-serif;
        cursor: pointer;
    }
    .post-card {
        align-items: center;
        padding-bottom: 30px;
        display: flex;
        justify-content: center;
        flex: 1 1 50%;
    }
    .post-img {
        display: flex;
        flex: 1 1 33%;
    }
    .post-body {
        display: flex;
        flex-direction: column;
        padding-left: 36px;
        padding-right: 36px;
        gap: 20px;
        height: 100%;
        align-items: flex-start;
        justify-content: center;
    }
    .author-head {
        align-items: baseline;
        display: flex;
        justify-content: flex-start;
        gap: 10px;
    }
    .head-text {
        font: 1000 42px/127% Montserrat, sans-serif;
    }
    .head-text-title {
        color: #dedede;
        font: 600 12px/120% 'Montserrat', sans-serif;
    }
    .author-img {
        max-width: 32px;
        max-height: 32px;
        flex: 1 1 60%;
        border-radius: 50%;
        box-sizing: content-box;
    }
    .post-name:hover {
        color: #cdeb09;
        cursor: pointer;
    }
    .post-name {
        display: flex;
        flex-direction: column;
        gap: 20px;
        color: #dedede;
    }
    .main-content {
        font: 600 16px/120% 'Montserrat', sans-serif;
    }
    .post-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #dedede;
        max-width: 80%;
    }
    .post-content-text {
        width: 70%;
        font: 600 18px/120% 'Instrumen Sans', sans-serif;
    }
    .post-content-title {
        font-weight: 700;
        font: 600 32px/120% 'Montserrat', sans-serif;
        color: #cdeb09;
    }
    .comming-tabs {
        font-weight: 700;
        font: 600 32px/120% 'Montserrat', sans-serif;
    }
    .other-info {
        font-weight: 500;
        font: 600 24px/120% 'Montserrat', sans-serif;
    }
    .other-tabs {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 10px;
        margin-bottom: 50px;
        width: 100vw;
        height: 100vh;
    }
</style>
